<style lang="scss">
label {
    display: block;
    margin-bottom: 4px;

    &:empty {
        display: none;
    }
}

input, textarea {
    background: #FFFFFF;
    border: 1px solid #e5e7e8;
    border-radius: 5px;
    font-family: Fira Sans, sans-serif;
    font-size: 16px;
    line-height: 19px;
    color: #333;
    padding: 15px 12px;
    margin: 0;
    width: 100%;
    box-sizing: border-box;

    // Иконка подстановки пароля в Safari
    &::-webkit-credentials-auto-fill-button {
        position: relative;
        left: -30px;
        top: -5px;
    }

    // Подпись про тип пароля в Safari
    &::-webkit-strong-password-auto-fill-button {
        padding-right: 25px;
    }
}

textarea {
    min-height: 150px;
}

.datetime-date {
    width: auto;
    display: inline-block;
}

.datetime-time {
    width: auto;
    display: inline-block;
}
</style>
<script lang="ts" context="module">
export function datePart(value?: string) {
    return value ? formatDate(new Date(value), '%Y-%M-%D') : '';
}

export function timePart(value?: string) {
    return value ? formatDate(new Date(value), '%h:%m') : '';
}
</script>
<script lang="ts">
import { formatDate } from '../email/format';

import TrixEditor from './TrixEditor.svelte';

export let type = 'text';
export let name: string | undefined;
export let placeholder: string | undefined = void 0;
export let value: string | number = '';
export let error = '';
export let autocomplete: string | undefined = void 0;
export let minlength: number | undefined = undefined;
export let disabled = false;
export let required = false;
export let autofocus = false;
export let tabindex: number | undefined = undefined;

const handleInput = (e: Event) => {
    const input = e.target as HTMLInputElement;
    if (input.type === 'number' || input.type === 'range') {
        value = input.valueAsNumber;
    } else if (type === 'datetime') {
        if (input.type === 'date') {
            updateDate({ date: input.value });
        } else if (input.type === 'time') {
            updateDate({ time: input.value });
        }
    } else {
        value = input.value;
    }
};

interface DatePayload {
    date?: string;
    time?: string;
}

function updateDate(payload: DatePayload) {
    let date: Date;
    if (value) {
        date = new Date(value);
    } else {
        date = new Date();
        date.setHours(19, 0, 0);
    }

    if (payload.date) {
        const [year, month, day] = payload.date.split('-').map(Number);
        date.setFullYear(year, month - 1, day);
    }

    if (payload.time) {
        const [hh, mm] = payload.time.split(':').map(Number);
        date.setHours(hh, mm);
    }

    value = date.toISOString();
}
</script>
<div class="input">
    <label for="fld-{name}">
        <slot></slot>
    </label>

    <!-- svelte-ignore a11y-autofocus -->
    {#if type === 'textarea'}
        <textarea {name} id="fld-{name}" {disabled} {required} {minlength} {tabindex} {autofocus} {placeholder}
            class:empty={!value}
            class:invalid={error}
            on:input={handleInput}
            on:input on:change>{value}</textarea>
    {:else if type === 'html'}
        <TrixEditor bind:value on:input />
    {:else if type === 'datetime'}
        <div class="datetime">
            <input type="date" class="datetime-date" {placeholder} name="{name}-date" id="fld-{name}-date" value={datePart(String(value) || '')} on:input={handleInput} />
            <input type="time" class="datetime-time" name="{name}-time" id="fld-{name}-time" value={timePart(String(value || ''))} on:input={handleInput} />
        </div>
    {:else}
        <input id="fld-{name}" {type} {name} {autocomplete} {disabled} {required} {minlength} value={value != null ? value : ''} {tabindex} {autofocus} {placeholder}
            class:empty={!value}
            class:invalid={error}
            on:input={handleInput}
            on:input on:change />
    {/if}

</div>
